
import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import yuklemeData from "../../utils/yukOptions/yuklemeData"
import bosaltmaData from "../../utils/yukOptions/bosaltmaData"
import { setResultModalData, showModal } from "../modal/modalSlice";
import { aracData, paketlemeData, paketlemeTypes, paymentData, yukData, routeData } from "../../utils/loadInitialData/data";
import { updateLoadItem, updateLoadItemForPublishing } from "../loadList/loadListSlice";
import axiosInstance from "../../axios/axiosInstance";
import { toastApiError } from "../../helper/api/toastApiError";
import locationData from "../../utils/locationData/locationOptions";

const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

const initialState = {
    route:  [
        {
            locationData: {
                il: "",
                ilce: "",
                lat: "",
                lng: "",
                location: "",
                bolge: "",
                ilId: "",
                ilceId: ""
            },
            adres: "",
            adresTarif: "",
            adresKaydedilsinMi: false,
            adresBaslik: "",
            date: "",
            dateEngec: "",
            saatBaslangic: "08:00",
            saatBitis: "18:00",
            saatAllTime: false,
            locationType: "yukleme",
            order: 1,
            sevkBicimleri:[
                {
                    id: 1,
                    name: "Forkliftle",
                    status: false,
                },
                {
                    id: 2,
                    name: "Rampadan",
                    status: false,
                },
                {
                    id: 3,
                    name: "Vinçle",
                    status: false,
                },
                {
                    id: 4,
                    name: "Elle",
                    status: false,
                },
                {
                    id: 5,
                    name: "Dökme",
                    status: false,
                },
                {
                    id: 6,
                    name: "Yandan",
                    status: false,
                },
                {
                    id: 7,
                    name: "Babalar Çıksın",
                    status: false,
                }
            ]
        },
        {
            locationData: {
                il: "",
                ilce: "",
                lat: "",
                lng: "",
                location: "",
                bolge: "",
                ilId: "",
                ilceId: ""
            },
    
            adres: "",
            adresTarif: "",
            adresKaydedilsinMi: false,
            adresBaslik: "",
            date: "",
            dateEngec: "",
            saatBaslangic: "08:00",
            saatBitis: "18:00",
            saatAllTime: false,
            locationType: "bosaltma",
            order: 2,
            sevkBicimleri:[
                {
                    id: 1,
                    name: "Forkliftle",
                    status: false,
                },
                {
                    id: 2,
                    name: "Rampadan",
                    status: false,
                },
                {
                    id: 3,
                    name: "Vinçle",
                    status: false,
                },
                {
                    id: 4,
                    name: "Elle",
                    status: false,
                },
                {
                    id: 5,
                    name: "Dökme",
                    status: false,
                },
                {
                    id: 6,
                    name: "Yandan",
                    status: false,
                },
                {
                    id: 7,
                    name: "Babalar Çıksın",
                    status: false,
                }
            ]
        }
    ],

    aracData: {
        aracSayisi: 1,
        aracTypeName: "",
        aracTypeId: "",
        kasaTypeName: "",
        kasaTypeId: "",
        kasaTypeOptions: [], 
        zeminType: {
            value:"",
            text: ""
        },
        digerOzellikler: ""
    },

    paymentData: {
        hedefNakliyefiyat: "",
        yukverenFiyat: "",
        fiyatlandirmaType: {
            value: 0,
            text: "TL"
        },
        fiyatYayinlansin: true,
        odemeSekli: {
            value: "",
            text: ""
        },
        odemeSekliDigerAciklama: "",
        yakitDurumu: {
            value: "",
            text: ""
        },
        yakitOrani: 0,
        komisyonDurumu: {
            value: "",
            text: ""
        },
        komisyonMiktari: 0
    },

    yukData: {
        //! options
        yuklemeTuru: {
            value: "",
            text:""
        },

        //! text
        yukTuru: "",

        //! bool
        yukADR: false,
        yukAdrDescription: "",

        agirlikBirim: {
            value: "",
            text: ""
        },
        toplamAgirlik: "",
        toplamHacim: "",
        yukDesc: "",
        yukunDegeri: "",
        companyLoadNumber: "",
        customsPlace: "",
        vesselDate: "",
        isFreeZone: false,
        ustUsteYuklenmesin: false,
    },

    paketlemeData: [
        {
            id: nanoid(),
            activePaketlemeTypeId: 1,
            paketlemeType: "Palet",
            list:[
                    {
                        id:nanoid(),
                        en: 120,
                        boy: 80,
                        yukseklik: "",
                        agirlik:"",
                        sayisi:""
                    }
                ]
        }
    ],

    paketlemeTypes: [
        {
            id: 1,
            name: "Palet",
            isOpen: true,           //! bu ekranda görünüp görünmeyeceğini belirler
            isOther: false          //! bu diğerlerinin içinde görünüp görünmeyeceğini belirler  
        },
        {
            id:2,
            name: "Kutu",
            isOpen: true,
            isOther: false
        },
        {
            id: 3,
            name: "Dökme",
            isOpen: true,
            isOther: false
        },

        {
            id: 4,
            name: "Big Bag",
            isOpen: false,
            isOther: true
        },
        {
            id: 5,
            name: "Varil Bidon",
            isOpen: false,
            isOther: true
        },
        {
            id: 6,
            name: "Teneke",
            isOpen: false,
            isOther: true
        },
        {
            id: 7,
            name: "IBC",
            isOpen: false,
            isOther: true
        },
        {
            id: 0,
            name: "Diğer",
            isOpen: false,
            isOther: true
        },
    ],

    yayinlamaSecenegi: null,

    routeDistance: null,

    //! bu route item veya paketleme item silinmek istenirse permmission almak için 
    routePermissionData: null,
    paketlemePermissionData: null,

    //! map modal açıldığında ilgili itemın datası
    routeItem:null,
    routeItemName:null,
    selectedItem: null,
    defaultRouteState:null,
    
    clearPermisionLoadDataPiece: null,

    //! localStorage da yapılan değişiklikten ayrı tutacağımız state
    memorieRouteData : null,

    //! bu show errors eğer submit esnasında zorunlu alanları doldurmazsa diye 
    showErrors: false,

    //! bu da kullanıcı sadece zorunlu alanları görüntülemek isterse diye
    showRequiredPlaces: false,

    //! other tools
    isLoadingAddLoad: false,
    isError: false,
    message: "",

    selectedRouteItemUpdate: null,
    selectedRouteItemTypeUpdate: null,


    //! bu yükler lsitesinde günceleme yaparsa çalışıyor
    isLoadingUpdateLoadPublishingType: false,


    //! bu yük güncelleme publish type tutmak için
    updatedItemPublishType: null,

    updatedItemPublishType2HourData: ""

}


export const updateLoad = createAsyncThunk("updateLoad/updateLoad", async(yukData, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/load/UpdateLoadNew`, yukData)

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Yük Kaydınız Başarıyla Güncellenmiştir", resultType: "success", btnText1: "Listeyi Görüntüle"}))
            thunkApi.dispatch(updateLoadItem(data.data))
        }
        else{
            const message = toastApiError(data, "Bir hata oluştu, lütfen daha sonra tekrar deneyin")
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: message, btnText1: "Listeyi Görüntüle"}))
        }
        return data
    } catch (error) {
        const message = toastApiError(error, "Bir hata oluştu, lütfen daha sonra tekrar deneyin")
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: message, routePath: "/yukler-listesi" , resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue({ message })
    }
})


export const updateLoadPublishingType = createAsyncThunk("updateLoad/updateLoadPublishingType", async(updatedData, thunkApi)=> {
    try {
        
        
        const {data} = await axiosInstance.post(`/load/UpdateLoadPublishingType`, updatedData)

        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Yük Kaydınız Başarıyla Güncellenmiştir", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        thunkApi.dispatch(updateLoadItemForPublishing(data))

        
        // const item = 

        
        // return {
        //     id: data.waitingLoadId
        // }

        return data
    } catch (error) {
        
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştus, lütfen daha sonra tekrar deneyin", routePath: "/yukler-listesi" ,resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

const updateLoadSlice = createSlice({
    name: "updateLoad",
    initialState,
    reducers: {

        addRouteItem: (state, action) => {
            const {type} = action.payload

            if(type === "yukleme"){
                const lastItemIndex = state.route.findLastIndex(item => item.locationType === "yukleme")

                const newItem = {...yuklemeData, id: nanoid() }
                const updatedList = [...state.route]

                updatedList.splice(lastItemIndex+1, 0, newItem)

                state.route = updatedList
            }

            if(type === "bosaltma"){
                const lastItemIndex = state.route.findLastIndex(item => item.locationType === "bosaltma")

                const newItem = {...bosaltmaData, id: nanoid() }
                const updatedList = [...state.route]

                updatedList.splice(lastItemIndex+1, 0, newItem)
                state.route = updatedList
            }

            //!
            const returnData = state.route.map(item => {
                const {id, ...others} = item
                return others
            })
            storage.setItem('routeData', JSON.stringify(returnData))
        },

        updateRouteItem: (state, action) => {
            state.route = state.route.map((item) => {
                if(item.id === action.payload.id){
                    return {...item, ...action.payload}
                }
                else{
                    return item
                }
            })

        },

        deleteRouteItem: (state, action) => {
            
            const updatedList = state.route.filter((item) => {
                return item.id !== action.payload.id
            })

            state.route = updatedList.map((item,i) => {
                return {...item, order: i+1}
            })

        },
        
        updateAracData: (state, action) => {
            
            state.aracData = {...state.aracData, ...action.payload}
        },

        updatePaymentData: (state, action) => {
            state.paymentData = {...state.paymentData, ...action.payload}
        },

        updateYukData: (state,action) => {
            state.yukData = {...state.yukData, ...action.payload}
        },

        //! bu paketleme item ı eklenmesi
        addPaketlemeItem: (state) => {
            const data = {
                id: nanoid(),
                activePaketlemeTypeId: 1,
                paketlemeType: "Palet",
                ustUsteYuklenmesin: false,
                ustUsteMiktar: 0,
                list:[
                    {
                        id: nanoid(),
                        en: 120,
                        boy: 120,
                        yukseklik: 0,
                        agirlik:0,
                        sayisi:0
                    }
                ]
            }
            state.paketlemeData = [...state.paketlemeData, data]
        },

        //! bu paketleme itemlarının güncellemesi
        updatePaketlemeItem: (state,action) => {
            state.paketlemeData = state.paketlemeData.map((item) => {
                if(item.id === action.payload.id){
                    return {...item, ...action.payload}
                }
                else{
                    return item
                }
            })
        },

        //! delete paketleme Item
        deletePaketlemeItem: (state, action) => {
            state.paketlemeData = state.paketlemeData.filter(item => {
                return item.id !== action.payload.id
            })
        },

        //!  u aynı paketleme item ından farklı ölçülerde eklemek için
        addPaketlemeDimensionItem: (state,action) => {
            const {id, dimensions} = action.payload
            state.paketlemeData = state.paketlemeData.map((item) => {
                if(item.id === id){
                    const list = [...item.list, {...dimensions, id: item.list.length+1}]
                    return {...item, list }
                }
                else{
                    return item
                }
            })
        },

        updatePaketlemeDimensionItem: (state,action) => {
            const {id, dimensionId, updatedData} = action.payload
            state.paketlemeData = state.paketlemeData.map((item) => {
                if(item.id === id){
                    const updatedList = item.list.map(item => {
                        if(item.id === dimensionId){
                            return {...item, ...updatedData}
                        }
                        return item
                    })
                    return {...item, list: updatedList}
                }
                return item
            })
        },

        //! rota planla aşaması değişiklikleri rotadaki değişiklikleri olduğu gibi kaydetmek için 
        setRoute: (state, action) => {
            state.route = action.payload
        },

        setRouteDistance: (state, action) => {
            state.routeDistance = action.payload
        },

        //! ve birde ilk update de verileri setlemek için(asag)
        setPaketlemeData: (state, action) => {
            state.paketlemeData = action.payload
        },

        setPaymentData: (state, action) => {
            state.paymentData = action.payload
        },

        setYukData: (state, action) => {
            state.yukData = action.payload
        },

        setAracData: (state, action) => {
            state.aracData = action.payload
        },

        //! localStorage a kaydedilen değişiklikleri güncelleyeceğimiz yerler bitiş (ffk)


        setRoutePermissionData: (state, action) => {
            state.routePermissionData = action.payload
        },

        //! bu paketleme item ı açıldığında permission almak için
        setPaketlemePermissonData: (state, action) => {
            state.paketlemePermissionData = action.payload
        },

        //! map modal açıldığında ilgili itemın datasını alan metod
        setRouteItem:(state,action) =>{
            state.routeItem = action.payload
        },

        setItemName:(state,action) =>{
            state.setItemName = action.payload
        },

        setErrors: (state, action) => {
            state.showErrors = action.payload
        },

        setRequiredPlacesErrors: (state,action) => {
            state.showRequiredPlaces = action.payload
        },
        
        setSelectedItem:(state,action) =>{
            state.selectedItem = action.payload
        },

        //! use memo kullanarak route dizisini haritadan seçim alanı için tuttuğumuz state
        setDefaultRouteState:(state,action)=>{
            state.defaultRouteState = action.payload
        },

        //! route dizisini haritadan seçim alanı için kaydetme ya da iptal olma durumunu ayarladığımız state
        setUpdateRouteMap:(state,action)=>{
            state.route = action.payload
        },

        //! bu yuk eklemede bölgesel yük eklemek için 
        getClearPermisionLoadDataPiece: (state,action) => {
            state.clearPermisionLoadDataPiece = action.payload 
        },

        //! burası bölgesel sıfırlama için
        clearLoadDataPiece: (state, action) => {
            const {typeId} = action.payload
            if(typeId === 1){
                state.route = state.route.map((item) => {
                    if(item.locationType === "yukleme"){
                        return {...routeData[0], order: item.order }
                    }
                    else{
                        return item
                    }
                })
            }

            if(typeId === 2){
                state.route = state.route.map((item) => {
                    if(item.locationType === "bosaltma"){
                        return {...routeData[2], order: item.order }
                    }
                    else{
                        return item
                    }
                })
            }

            if(typeId === 1 || typeId === 2){
                state.routePermissionData = null
                state.paketlemePermissionData = null
                state.routeItem =null
                state.routeItemName =null
                state.selectedItem = null
                state.defaultRouteState =null
                state.routeDistance = 0
            }

            if(typeId === 4){
                state.paketlemeData = paketlemeData
                state.paketlemeTypes = paketlemeTypes
                state.yukData = yukData
            }
            if(typeId === 5){
                state.aracData = aracData
            }
            if(typeId === 6){
                state.paymentData = paymentData
            }
        },

        setSelectedRouteItemUpdate:(state,action)=>{
            state.selectedRouteItemUpdate = action.payload
        },

        setSelectedRouteItemTypeUpdate:(state, action) => {
            state.selectedRouteItemTypeUpdate = action.payload
        },

        //! localStore dan gelen dataya yedek olarak tuttuğumuz dizi
        setMemorieRouteData:(state,action)=>{
            state.memorieRouteData = action.payload
        },

        setUpdatedItemPublishType:(state, action) => {
            state.updatedItemPublishType = action.payload
        },

        setUpdatedItemPublishType2HourData:(state, action) => {
            state.updatedItemPublishType2HourData = action.payload
        },

        //! kayıtlı adres seçildiğinde güncelleme rotasını doldurmak için
        setKayitliAdresRouteItem:(state, action) => {
            const {routeId, data} = action.payload
            const selectedLocation = (data?.locationId !== null && data?.locationId !== undefined
                ? locationData.find(innerItem => String(innerItem.townId) === String(data.locationId))
                : undefined)
                ?? locationData.find(innerItem => innerItem.town === data?.addressTown && innerItem.city === data?.addressCity)
                ?? locationData.find(innerItem => innerItem.town === data?.addressTown)

            state.route = state.route.map(item => {
                if(item.id !== routeId) return item

                return {
                    ...item,
                    locationData: selectedLocation ? {
                        il: selectedLocation.city,
                        ilce: selectedLocation.town,
                        bolge: selectedLocation.region,
                        ilId: selectedLocation.cityId,
                        ilceId: selectedLocation.townId,
                        lat: data?.addressLat ?? selectedLocation.lat,
                        lng: data?.addressLong ?? selectedLocation.lng,
                        location: selectedLocation.location,
                    } : {
                        ...item.locationData,
                        lat: data?.addressLat ?? item.locationData?.lat,
                        lng: data?.addressLong ?? item.locationData?.lng,
                    },
                    adres: data?.address,
                    adresTarif: data?.addressInfo || "",
                    adresBaslik: data?.addressName ?? ""
                }
            })
        }

    },
    extraReducers:(builder)=> {
        builder

        //! updateLoad
        .addCase(updateLoad.pending, (state)=> {
            state.isLoadingAddLoad = true
        })

        .addCase(updateLoad.fulfilled, (state)=> {
            state.isLoadingAddLoad = false
            state.updatedItemPublishType = null
            state.updatedItemPublishType2HourData = ""
        })

        .addCase(updateLoad.rejected, (state)=> {
            state.isLoadingAddLoad = false
            state.isError = true
        })


        //! updateLoadPublishingType
        .addCase(updateLoadPublishingType.pending, (state)=> {
            state.isLoadingUpdateLoadPublishingType = true
        })

        .addCase(updateLoadPublishingType.fulfilled, (state, action)=> {
            state.isLoadingUpdateLoadPublishingType = false
        })

        .addCase(updateLoadPublishingType.rejected, (state)=> {
            state.isLoadingUpdateLoadPublishingType = false
        })



    }
})


export const {

    addRouteItem,
    updateRouteItem,
    deleteRouteItem,

    updateAracData,
    updatePaymentData,
    updateYukData,


    addPaketlemeItem,
    updatePaketlemeItem,
    deletePaketlemeItem,

    addPaketlemeDimensionItem,
    updatePaketlemeDimensionItem,

    setRouteDistance,
    setRoute,
    setRoutePermissionData,
    setPaketlemePermissonData,

    setRouteItem,
    setItemName,

    setErrors,
    setRequiredPlacesErrors,
    
    setSelectedItem,
    setDefaultRouteState,
    setUpdateRouteMap,

    getClearPermisionLoadDataPiece,
    clearLoadDataPiece,
    //! localStorage kaydetme
    setMemorieRouteData,

    //! localStorage güncelleme
    setAracData,
    setYukData,
    setPaymentData,
    setPaketlemeData,


    setSelectedRouteItemUpdate,
    setSelectedRouteItemTypeUpdate,

    setUpdatedItemPublishType,
    setUpdatedItemPublishType2HourData,
    setKayitliAdresRouteItem

} = updateLoadSlice.actions
export default updateLoadSlice.reducer
